import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import AdminDashboard from "./AdminDashboard";
import Transactions from "./Transaction";
import UserManagement from "./UserList";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={
          <Layout>
            <AdminDashboard />
          </Layout>
        }
      />

      <Route
        exact
        path="/user-list"
        element={
          <Layout>
            <UserManagement />
          </Layout>
        }
      />
      <Route
        exact
        path="/transactions"
        element={
          <Layout>
            <Transactions />
          </Layout>
        }
      />
    </Routes>
  );
};

export default AdminRoutes;
